import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ModuloStatus } from './modulo.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {

constructor(private http: HttpClient) { }
  getModulosStatus(): Observable<ModuloStatus[]> {
    const url = `${environment.baseURL}Modulo/GetModulosStatus`;

    return this.http.get<ModuloStatus[]>(url).pipe(
      tap(modulos => {
        // Salva o array no localStorage
        localStorage.setItem('modulosStatus', JSON.stringify(modulos));
      }),
      catchError(error => {
        console.error('Erro ao obter módulos:', error);
        return throwError(() => error);
      })
    );
  }

  isModuloAtivo(nomeModulo: string): boolean {
    const data = localStorage.getItem('modulosStatus');
    if (!data) return false;

    const modulos: ModuloStatus[] = JSON.parse(data);

    const modulo = modulos.find(m => m.NM_MODL.toLowerCase() === nomeModulo.toLowerCase());
    if (!modulo) return false;

    // Sem configuração no banco (null/undefined) → liberado, alinhado ao middleware da API.
    return modulo.FL_ATVO !== false;
  }


}
